import React from 'react';
import styles from './setting.module.scss';
import { SettingContent } from './setting-content';
import { SettingHeader } from './setting-header';
export const Setting = ({ setting, actionHandler, isCustomerLLMAccount = false, provider = '', }) => {
    const actionHandlerCB = (type) => {
        actionHandler(type, setting);
    };
    return (React.createElement("div", { className: styles.settingContainer },
        React.createElement(SettingHeader, { actions: setting.actions, settingName: setting.settingName, settingSubTitle: setting.settingSubTitle, learnMore: setting.learnMore, actionHandler: actionHandlerCB }),
        React.createElement(SettingContent, { configs: setting.configs, isCustomerLLMAccount: isCustomerLLMAccount, provider: provider })));
};
//# sourceMappingURL=setting.js.map